export default "__VITE_ASSET__irfYMpUS__"